export default __webpack_public_path__ + "static/FAM1063WD57-1053e4998bcb0f4afec69feb6ef91b5f.jpg";